
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { NewSecondaryButton } from "../../styles/styledComponents";
import PetCard from "../PetCard/PetCard";

interface IPetSelection {
  petsActive: IPetItemResponse[] | null;
  selectedPets: IPetItemResponse[];
  visitType?: string;
  title?: string;
  subtitle?: string;
  handleSelectPet: (pet: IPetItemResponse) => void;
  handleClickAddAPet: () => void;
  hideAddPet?: boolean;
}

const PetSelection = ({
  petsActive,
  selectedPets,
  visitType,
  title,
  subtitle = "Select one or more pets to continue.",
  handleSelectPet,
  handleClickAddAPet,
  hideAddPet,
}: IPetSelection) => {
  return (
    <>
      <div
        className="p-4 w-full
      flex flex-col justify-between gap-4 border border-taupe-50 rounded-xl">
        <div className="flex flex-col gap-1">
          <div className="text-lg font-semibold">
            {title ?? `Which of your pets need to book a ${visitType}?`}
          </div>
          <div className="text-sm text-gray-1">
            {subtitle}
          </div>
        </div>
        <div className="bg-red-60">
          <div className="flex flex-col gap-3">
            {petsActive?.map((pet: IPetItemResponse) => (
              <a
                key={pet.id}
                className="w-full"
                onClick={() => handleSelectPet(pet)}
              >
                <PetCard
                  isActive={
                    !!selectedPets?.find((p: IPetItemResponse) => {
                      return p.id === pet.id;
                    })
                  }
                  image={pet.image}
                  pet={pet}
                  notBold={false}
                  displaySoc={true}
                  innerClassName="!pt-[1.35rem]"
                />
              </a>
            ))}
            {!hideAddPet && (
              <div
                className="p-3 border border-taupe-50 rounded-2xl cursor-pointer"
                onClick={handleClickAddAPet}
              >
                <NewSecondaryButton startIcon={<AddIcon />}>
                  Add Pet
                </NewSecondaryButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PetSelection;
